import { IAddressOption, IAddressSearchResponse } from './types';

export default class VerifyAddressResponse {
  public suggestedAddresses: IAddressOption[];

  constructor(apiResponseData: IAddressSearchResponse[], requestedCountryValue: string) {
    this.suggestedAddresses = apiResponseData.map((address: IAddressSearchResponse) => ({
      ...address,
      requestedCountryValue,
    }));
  }
}
